import styled, { css } from 'styled-components';
import { NavLink } from 'react-router-dom';

// Components
import { ArrowBottom } from '../../../../../assets/icons/ArrowBottom';

export const Link = styled(NavLink)`
  display: flex;
  text-decoration: none;
  border-radius: 0.5rem;
  padding: 1rem;

  &.active {
    background-color: ${({ theme }) =>
      theme.colors.navigationActive}; /* CAMBIO: Color navegación según Figma */
    p {
      text-shadow: 0 0 1px;
    }
  }
`;

export const MenuButton = styled(NavLink)`
  display: flex;
  gap: 1rem;
  text-decoration: none;
  transition: opacity 0.2s ease-out;
  align-items: center;

  p {
    border-radius: 0.5rem;
    width: 100%;
    padding: 1rem;
  }

  &.active {
    p {
      background-color: ${({ theme }) =>
        theme.colors
          .navigationActive}; /* CAMBIO: Color navegación según Figma */
      text-shadow: 0 0 1px;
    }
  }
`;

export const Item = styled.li``;

interface ArrowIconProps {
  isActive: boolean;
}

export const ContainerArrowIcon = styled.div<ArrowIconProps>`
  svg > path {
    fill: ${({ theme }) => theme.colors.garnet};
  }
  ${({ isActive }: ArrowIconProps) => css`
    transform: rotate(${isActive ? '-90deg' : '0deg'});
    transition: transform 0.2s;
  `}
`;

interface ListProps {
  isCollapsed: boolean;
  height: number;
}

export const List = styled.ul<ListProps>`
  transition: all 0.2s;
  margin-left: 4rem;

  ${({ isCollapsed, height }: ListProps) => css`
    ${isCollapsed
      ? css`
          height: ${height}rem;
          visibility: visible;
          opacity: 1;
        `
      : css`
          height: 0rem;
          visibility: hidden;
          opacity: 0;
        `}
  `};
`;

export const SubItem = styled.li``;

export const ArrowDown = styled(ArrowBottom)``;
